import React from 'react';
import './customerInvoices.scss';

import { useAuth } from  '../../contexts/auth'; 
import { createStore } from 'devextreme-aspnet-data';

import DataGrid, {
  Column,
  Export,
  Popup,
  Form,
  Button,
  Pager,
  Paging,
  FilterRow,
  HeaderFilter,
  RowDragging,
  Lookup,
  Item,
  Toolbar,
  Editing,
  Selection,
  Summary,
  Format,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';

import {Button as ToolbarButton} from 'devextreme-react/button';
import {Popup as ToolbarPopup} from 'devextreme-react/popup';

import { useState, useEffect, useCallback  } from "react";
import { formatNumber } from 'devextreme/localization';


const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaClienteDettaglio'
const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaClienteAltriDati'

export default function CustomerInvoiceDetailRows(props) {

    const filterPayload = { 
        idSuper: props.myKey,
        noNotes: false,
        noHidden: false
    };

    const isEditable = props.status === 1 ? true : false;
    const isUpdateble = props.status !== 3 ? true : false;
    console.log("Modificabile: " + isEditable);

    const [tipiArticolo, setTipiArticolo] = useState({});
    const [um, setUm] = useState({});
    //const [articoli, setArticoli] = useState({});
    const [imposte, setImposte] = useState({});
    //const [categorie, setCategorie] = useState({});
    const [editableOrder, setEditableOrder] = useState(isEditable);
    const [updatebleOrder, setUpdatebleOrder] = useState(isUpdateble);
    const [currentRow, setCurrentRow] = useState(0);
    const [isRowSelected, setIsRowSelected] = useState(false);
    const { user } = useAuth(); 

    const [isPopupVisible2, setPopupVisibility2] = useState(false);
    const togglePopup2 = () => {
      setPopupVisibility2(!isPopupVisible2);
    };

    useEffect(() => {

      const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoArticolo';
      var newUrl =  newServiceUrl + "/GetAction";

      const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/UnitaMisura';
      var newUrl2 =  newServiceUrl2 + "/GetAction";

      // const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_Articoli';
      // var newUrl3 =  newServiceUrl3 + "/GetAction";

      const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Imposta';
      var newUrl4 =  newServiceUrl4 + "/GetAction";

      // const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ArticoloCategoria';
      // var newUrl5 =  newServiceUrl5 + "/GetAction";

      const fetchData = async () => {
        try {

          const response = await fetch(newUrl);
          const json = await response.json();
          console.log(json);
          setTipiArticolo(json);

          const response2 = await fetch(newUrl2);
          const json2 = await response2.json();
          console.log(json2);
          setUm(json2);

          // const response3 = await fetch(newUrl3);
          // const json3 = await response3.json();
          // console.log(json3);
          // setArticoli(json3);

          const response4 = await fetch(newUrl4);
          const json4 = await response4.json();
          console.log(json4);
          setImposte(json4);

          // const response5 = await fetch(newUrl5);
          // const json5 = await response5.json();
          // console.log(json5);
          // setCategorie(json5);

        } catch (error) {
          console.log("error", error);
        }
      };
      fetchData();
    }, []);

    // async function getArticle(id)  {

    //     if (id == null)
    //       id = 0;
        
    //       var serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Articolo/GetAction/' + id;
    
    //     const requestOptions = {
    //       method: 'GET',
    //       //body: JSON.stringify(t),
    //       headers: {
    //         'Content-Type': 'application/json',
    //         //Authorization: `Bearer ${this.state.loggedUser.token}`
    //       }
    //     };
    
    //     return fetch(serviceUrl, requestOptions)
    //     .then(response => {
    //       if(response.ok) return response.json();
    //       //Global.CheckResponseAuth(response);
    //       return null;
    //     })
    
    //     .then(data => { 
    //       return data;
    //     })
    //     .catch(error => { notify(error, 'error', 5000); }); 
    // }

    // async function setArticleValues(newData, value, currentRowData) {

    //     console.log("ARTICOLO: " + value);
    //     return getArticle(value).then(data => {
    //       newData.articoloId = value;
    //       newData.codice = data.codice;
    //       newData.codiceAlias = data.codiceFornitore;
    //       newData.paUnitario = data.prezzoAcquisto;
    //       newData.descrizione = data.descrizione;
    //       newData.impostaId = data.impostaId;
    //       newData.tipoRigaId = data.tipoArticoloId;
    //       newData.umid = data.umid;
    //       newData.paSconto = 0;
    //       newData.paScontato = 0;
    //       newData.paTotale = 0;
    //       newData.quantità= 1;
    //       newData.pvPercRicarico = data.percRicarico;
    //   });
    // }


    function customizeText(data) {
      return `Righe: ${data.value}`;
    }

    function customizeData(data) {
      return `Totale: ${formatNumber(data.value, '###,##0.00')}`;
    }

    function onInitNewRow(e) {
      e.data.fatturaId = props.myKey;
    };

    function onRowSelectionChanged({ selectedRowsData }) {
      const data = selectedRowsData[0];
      if (data !== null && data !== undefined) {
        setCurrentRow(data.id);
        //setCurrentDocNo(data.numero);
        setIsRowSelected(true);
       
      } else{
        setIsRowSelected(false);
      }
      
    }


    const onEditorPreparing = (e) => {
      if (e.parentType === "dataRow" && e.dataField === "articoloId") {
        //e.editorOptions.disabled = typeof e.row.data.tipoRigaId !== "number";
        e.editorOptions.disabled = typeof e.row.data.categoriaId !== "number";
        //notify(error, 'Modificato', 5000);
        //notify(`Modificato`, { type: 'warning' });
      }
    }

    // const getFilteredArticoli = useCallback(
    //     (options) => {
    //       return {
    //         key: "id",
    //         store: new CustomStore({
    //           load: function (loadOptions) {
    //             // fake call server to get the list of article
    //             return new Promise((resolve) => {
    //               setTimeout(() => {
    //                 const res = loadOptions.filter
    //                   ? articoli.filter((c) => c.categoriaId === options.data.categoriaId)
    //                   : articoli;
    //                 resolve(res);
    //               }, 500);                
    //             });
    //           },
    //           byKey: function (key) {
    //             return new Promise((resolve) => {
    //               resolve(articoli.find((c) => c.id === key));
    //             });
    //           }
    //         }),
    //         filter: options.data ? ["categoriaId", "=", options.data.categoriaId] : null
    //       };
    //     },
    //     [articoli]
    //   );

  const remoteDataSource = createStore({

    key: 'id',
    loadUrl: serviceUrl + '/Find',
      
    onBeforeSend: (method, ajaxOptions) => {
      if (method == "load" ) {    
        //console.log("CHIAVE: " + filterPayload.idSuper);       
        var payload = ajaxOptions.data;
        payload.values = JSON.stringify(filterPayload);
        ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
    ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
      
  });

  const remoteDataSource2 = createStore({
  
    key: 'id',
    loadUrl: serviceUrl2 + '/FindByRigaFattura/' + currentRow,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },  
    insertUrl: serviceUrl2 + '/InsertAction',
    updateUrl:serviceUrl2 + '/UpdateAction',
    deleteUrl: serviceUrl2 + '/DeleteAction'
    
  });

  function calculateImportoTotale(rowData) {
      return (rowData.importoUnitario - (rowData.importoUnitario / 100 * rowData.percSconto)) * rowData.quantità;
  };

  function calculateIdRiga(rowData) {
    return currentRow;
};


  function onReorder(e) {
    e.promise = processReorder(e);
  }
  
  async function processReorder(e) {
    
    const visibleRows = e.component.getVisibleRows();
    const newOrderIndex = visibleRows[e.toIndex].data.orderIndex;

    await remoteDataSource.update(e.itemData.id, { orderIndex: newOrderIndex });
    await e.component.refresh();
  }

  function onRowInserting(e) {
    e.data.createBy = user.name;
  };

  function onRowInserting2(e) {
    e.data.fatturaClienteDettaglioId = currentRow;
  };


  function onRowUpdating(e) {
    e.newData.updateBy = user.name;
  };

  
  const renderContent2 = () =>  {
    return (
      <div>
      
    <DataGrid id="grid-subcontainer"
      dataSource={remoteDataSource2}
      onRowInserting={onRowInserting2}
      dateSerializationFormat= {'yyyy-MM-dd'}
    >
      <Selection mode="single" />
      <Toolbar>
        <Item name="addRowButton"  />
      </Toolbar>
      <Editing
        mode="row"
        allowUpdating={true}
        allowAdding={true}
        allowDeleting={true}
        useIcons={true}
      ></Editing>
      <Column dataField="id" visible={false}/>
      <Column dataField="fatturaClienteDettaglioId" visible={false} calculateCellValue={calculateIdRiga}/>
      <Column dataField="tipoDato" width={140}/>
      <Column dataField="riferimentoTesto" caption ="Rif. Testo"/>
      <Column dataField="riferimentoNumero"  caption ="Rif. Numero" width={140} >
        <Format type="fixedPoint" precision={2} />
      </Column>
      <Column dataField="riferimentoData" dataType="date" caption ="Rif. Data" format= {'dd/MM/yyyy'} width={120} />
    </DataGrid>
    </div>            
    )
  }


  const editorOptions = { readonly: true, format: '#,##0.00'};
    return (
  
      <div>

        <DataGrid id="grid-container"
            dataSource={remoteDataSource}
            showBorders={true}
            columnAutoWidth={true}
            onInitNewRow={onInitNewRow}
            onEditorPreparing={onEditorPreparing}
            onRowUpdating={onRowUpdating}
            onRowInserting={onRowInserting}
            onSelectionChanged={onRowSelectionChanged}
            //onCellPrepared={onCellPrepared}
            //onToolbarPreparing = {onToolbarPreparing}
        >
          <Paging  defaultPageSize={40}/>
          <Pager showPageSizeSelector={true} showInfo={true} />

          <Toolbar>
            <Item location="after">
              <ToolbarButton className="offer-toolbar"
                icon='columnchooser'
                hint='Altri dati gestionali'
                onClick={togglePopup2}
                disabled={!isRowSelected || !isEditable} 
                visible={true}/>
            </Item>
            <Item name="addRowButton"  />
            
          </Toolbar>
          <RowDragging
            allowReordering={editableOrder}
            onReorder={onReorder}
            dropFeedbackMode="push"
          />

            <HeaderFilter visible={true} />
            <Summary>
            <TotalItem
                column="codice"
                summaryType="count"
                customizeText={customizeText}
            />
            <TotalItem
              column="paTotale"
              summaryType="sum" 
              customizeText={customizeData}
              />
            </Summary>
            <Selection mode="single" />
            <Editing
              mode="row"
              allowUpdating={updatebleOrder}
              allowAdding={editableOrder}
              allowDeleting={editableOrder}
              useIcons={true}
            >
              
              <Popup   title= "&nbsp;&nbsp;&nbsp;Dettaglio " showTitle={true} width={800} height={625} />
         
              <Form>
                <Item itemType="group" caption="" colCount={2} colSpan={2}>
                
                  <Item dataField="id"/>
                
                  <Item dataField="codiceAlias" />
              
                  <Item dataField="descrizione" colSpan={2}/>
                  <Item dataField="tipoRigaId" editorType="dxSelectBox"/>  
          
                  <Item dataField="impostaId" editorType="dxSelectBox"/> 
                 
                  <Item dataField="umid" editorType="dxSelectBox"/>
                  <Item dataField="percSconto" editorOptions={editorOptions}/>
                  <Item dataField="importoScontato" editorOptions={editorOptions}/>
                  <Item dataField="importoTotale" editorOptions={editorOptions}/>
                  <Item colSpan={2}/>
                </Item> 
               
              </Form>
             

            </Editing>
            <Column dataField="id" visible={false}/>
            <Column dataField="fatturaId" visible={false}/>
            
            
            <Column dataField="codiceAlias" caption="Codice" width={100} allowEditing={editableOrder}/>
            <Column dataField="descrizione" caption="Descrizione" width={480} allowEditing={editableOrder}/>
            <Column dataField="tipoRigaId" caption="Tipo"  width={60}  allowEditing={editableOrder}>
              <Lookup dataSource={tipiArticolo} valueExpr="id" displayExpr="codice"/>
            </Column>
            <Column dataField="impostaId" caption="IVA" width={60} allowEditing={editableOrder}>
              <Lookup dataSource={imposte} valueExpr="id" displayExpr="codice" />
            </Column> 
            <Column dataField="ritenuta" caption="Rit." width={80}/>
            <Column dataField="umid" caption="UM" width={60} allowEditing={editableOrder}>
              <Lookup dataSource={um} valueExpr="id" displayExpr="codice" />
            </Column>
            <Column dataField="quantità" caption="Q.tà" width={80} allowEditing={editableOrder}/>
            <Column dataField="importoUnitario" caption="Importo Unit." allowEditing={editableOrder}>
              <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="percSconto" caption="% Sconto" allowEditing={editableOrder}>
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="importoScontato"  caption="Importo Scontato" allowEditing={editableOrder}>
              <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="importoTotale" calculateCellValue={calculateImportoTotale} caption="Totale" allowEditing={false}>
              <Format type="fixedPoint" precision={2} />
            </Column> 

            <Column dataField="updateBy" visible={false}/>
            <Column dataField="createBy" visible={false}/> 
        </DataGrid>

        <div>
        <ToolbarPopup
          width={1020}
          height={640} 
          showTitle={true}
          title="Altri dati gestionali"
          visible={isPopupVisible2}
          hideOnOutsideClick={true}
          onHiding={togglePopup2}
          contentRender={renderContent2}
        > 
        </ToolbarPopup> 
        </div>

        </div>  
   
   )
};